/**
 * Grid overlay — render-exempt file (test-spec §7.2): draws the segments
 * computed by shared/grid verbatim; the geometry itself is covered there.
 */

import { Container, Graphics } from "pixi.js";
import { buildGridLines, type MapState } from "@asarimitsuha/table-core";

export function drawGridOverlay(world: Container, map: MapState): Graphics {
  const grid = new Graphics();
  const config = { cellSizePx: map.cellSizePx, feetPerCell: map.feetPerCell };
  for (const line of buildGridLines(map.widthCells, map.heightCells, config)) {
    grid.moveTo(line.x1, line.y1).lineTo(line.x2, line.y2);
  }
  grid.stroke({ width: 1, color: 0x3a3f4d, pixelLine: true });
  world.addChild(grid);
  return grid;
}
